import { Routes, Route, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import HomePage from './HomePage';
import DoctorLoansPage from './DoctorLoansPage';
import EquipmentLoansPage from './EquipmentLoansPage';
import ProjectLoansPage from './ProjectLoansPage';
import ContactPage from './ContactPage';
import AboutPage from './AboutPage';
import Footer from './Footer';
import MortgageLoanPage from './MortgageLoanPage';
import HomeLoansPage from './HomeLoansPage';
import AgricultureLoanPage from './AgricultureLoanPage';
import EducationLoanPage from './EducationLoanPage';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('nav')) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className={`sticky top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white shadow'
      }`}>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2" onClick={closeMenu}>
              <img 
                src="/assets/ac_logo_no_background.png" 
                alt="Avalue Capital Logo" 
                className="h-8 w-auto object-contain"
              />
              <span className="text-lg font-semibold text-gray-800 hidden sm:block">Avalue Capital</span>
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-6">
              <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium">
                Home
              </Link>
              <Link to="/doctor-loans" className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium">
                Doctor Loans
              </Link>
              <Link to="/equipment-loans" className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium">
                Equipment Loans
              </Link>
              <Link to="/project-loans" className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium">
                Project Loans
              </Link>
              <Link to="/about" className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium">
                About
              </Link>
              <Link to="/contact" className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium">
                Contact
              </Link>
              {/* <Link to="/mortgage-loans" className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium">
                Mortgage Loan
              </Link>
              <Link to="/agriculture-loans" className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium">
                Agriculture Loan
              </Link> */}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition-colors duration-200"
              aria-label="Toggle menu"
            >
              <div className="w-6 h-6 flex flex-col justify-center items-center">
                <span className={`block w-5 h-0.5 bg-current transition-all duration-300 ${
                  isMenuOpen ? 'rotate-45 translate-y-1' : '-translate-y-1'
                }`}></span>
                <span className={`block w-5 h-0.5 bg-current transition-all duration-300 ${
                  isMenuOpen ? 'opacity-0' : 'opacity-100'
                }`}></span>
                <span className={`block w-5 h-0.5 bg-current transition-all duration-300 ${
                  isMenuOpen ? '-rotate-45 -translate-y-1' : 'translate-y-1'
                }`}></span>
              </div>
            </button>
          </div>

          {/* Mobile Menu */}
          <div className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
            isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}>
            <div className="py-4 space-y-3 border-t border-gray-200">
              <Link 
                to="/" 
                className="block py-3 px-4 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors duration-200 font-medium"
                onClick={closeMenu}
              >
                Home
              </Link>
              <Link 
                to="/doctor-loans" 
                className="block py-3 px-4 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors duration-200 font-medium"
                onClick={closeMenu}
              >
                Doctor Loans
              </Link>
              <Link 
                to="/equipment-loans" 
                className="block py-3 px-4 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors duration-200 font-medium"
                onClick={closeMenu}
              >
                Equipment Loans
              </Link>
              <Link 
                to="/project-loans" 
                className="block py-3 px-4 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors duration-200 font-medium"
                onClick={closeMenu}
              >
                Project Loans
              </Link>
              <Link 
                to="/about" 
                className="block py-3 px-4 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors duration-200 font-medium"
                onClick={closeMenu}
              >
                About
              </Link>
              <Link 
                to="/contact" 
                className="block py-3 px-4 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors duration-200 font-medium"
                onClick={closeMenu}
              >
                Contact
              </Link>
              {/* <Link 
                to="/mortgage-loans" 
                className="block py-3 px-4 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors duration-200 font-medium"
                onClick={closeMenu}
              >
                Mortgage Loan
              </Link>
              <Link 
                to="/agriculture-loans" 
                className="block py-3 px-4 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors duration-200 font-medium"
                onClick={closeMenu}
              >
                Agriculture Loan
              </Link> */}
            </div>
          </div>
        </div>
      </nav>
      <main className="mx-auto">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/doctor-loans" element={<DoctorLoansPage />} />
          <Route path="/equipment-loans" element={<EquipmentLoansPage />} />
          <Route path="/project-loans" element={<ProjectLoansPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/mortgage-loans" element={<MortgageLoanPage />} />
          <Route path="/home-loans" element={<HomeLoansPage />} />
          <Route path="/agriculture-loans" element={<AgricultureLoanPage />} />
          <Route path="/education-loan" element={<EducationLoanPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
